import { baseApi, PagedTableDto } from './base-api'

export const jobApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getJobs: build.query<any, PagedTableDto>({
      query: (dto) => ({
        url: `jobs/getjobs?pageNumber=${dto.page + 1}&${dto.getFilters()}`,
      }),
      transformResponse: (response: any, meta, arg) => {
        var pagination = JSON.parse(meta.response.headers.get("X-Pagination"));

        return {
          list: response,
          pagination: pagination
        };
      }
    }),
    getJob: build.query<any, any>({
      query: (equipmentId) => ({
        url: `jobs/getjob/${equipmentId}`,
      }),
    }),
    createJob: build.mutation<any, any>({
      query: (body) => ({
        url: 'jobs/addjob',
        method: 'post',
        body: body
      }),
    }),
    updateJob: build.mutation<any, any>({
      query: (body) => ({
        url: `jobs/updatejob/${body.id}`,
        method: 'put',
        body: body
      }),
    }),
    completeJob: build.mutation<any, any>({
      query: (id) => ({
        url: `jobs/completejob/${id}`,
        method: 'post',
      }),
    }),
    invoiceJob: build.mutation<any, any>({
      query: (id) => ({
        url: `jobs/invoicejob/${id}`,
        method: 'post',
      }),
    }),
    deleteJob: build.mutation<any, any>({
      query: (id) => ({
        url: `jobs/deletejob/${id}`,
        method: 'delete',
      }),
    }),
    // Used for tablet
    sendJob: build.mutation<any, any>({
      query: (body) => ({
        url: `jobs/updatejob/${body.id}`,
        method: 'put',
        body: body
      }),
    }),
    syncJobs: build.mutation<any, any>({
      query: (lastModifiedOn) => ({
        url: `jobs/getjobsforsync?lastmodifiedon=${lastModifiedOn}`,
      })
    }),
    sendJobAssets: build.mutation<any, any>({
      query: (body) => ({
        url: `jobs/updatejobasset/${body.id}`,
        method: 'put',
        body: body
      }),
    }),
  }),
  overrideExisting: true,
})

export const { 
  useGetJobsQuery, useGetJobQuery, useCreateJobMutation, useUpdateJobMutation,
  useCompleteJobMutation, useSendJobMutation, useSendJobAssetsMutation, useDeleteJobMutation,
  useInvoiceJobMutation
} = jobApi